import { useTranslation } from "react-i18next";
import SwapHorizOutlinedIcon from "@mui/icons-material/SwapHorizOutlined";
import { MenuItem } from "@mui/material";

import classes from "./SwitchProductVersions.module.less";
import Modal, { ModalSize } from "~/common/components/Modal";
import { Button } from "~/common/components/Button/Button";
import { Stacker } from "~/common/components/Stacker/Stacker";
import { LinkButton } from "~/common/components/Link";
import { useBooleanState } from "../../../../common/hooks/useBooleanState";

interface Props {
  className?: string;
  switchProductVersion: () => void;
  menuClassName?: string;
  isB2BCart?: boolean;
}

export const SwitchProductVersions = ({ className, menuClassName, isB2BCart = false, switchProductVersion }: Props) => {
  const { t } = useTranslation();

  const { val: modalOpen, setTrue: open, setFalse: close } = useBooleanState(false);

  if (!window.SCHA.feature.showSwitchToNewProductVersionButton) {
    return null;
  }

  const onSave = () => {
    close();
    switchProductVersion();
  };

  const switchProductVersionBtn = (
    <LinkButton
      iconBefore={<SwapHorizOutlinedIcon className={classes.iconButton} />}
      onClick={() => open()}
      data-test-id={"btn-load-all-pna"}
      className={className}
    >
      {t("cartPage.bulkUpload.btn.useNewestProductVersions")}
    </LinkButton>
  );

  return (
    <>
      {isB2BCart ? <MenuItem className={menuClassName}>{switchProductVersionBtn}</MenuItem> : switchProductVersionBtn}

      {modalOpen && (
        <Modal
          size={ModalSize.SMALL}
          onClose={close}
          hideClose={true}
          title={t("cartPage.bulkUpload.btn.useNewestProductVersions")}
          footerChildren={
            <Stacker gap={8} direction={"row"}>
              <Button variant={"text"} onClick={close}>
                {t("common.no")}
              </Button>
              <Button color="primary" onClick={onSave}>
                {t("common.yes")}
              </Button>
            </Stacker>
          }
        >
          <p>{t("cartPage.modal.switchProductVersion.bodyContent")}</p>
        </Modal>
      )}
    </>
  );
};
